import { render, staticRenderFns } from "./TickerAdminListOptions.vue?vue&type=template&id=11c639d4&scoped=true"
import script from "./TickerAdminListOptions.vue?vue&type=script&lang=js"
export * from "./TickerAdminListOptions.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminListOptions.vue?vue&type=style&index=0&id=11c639d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c639d4",
  null
  
)

export default component.exports